import React from 'react';

function IconButton({
	icon,
	disabled,
	onClick = () => {},

	/* Optional props */
	classNameBTN,
	classNameIMG,
}) {
	return (
		<button
			className={`${classNameBTN} ${disabled && 'cursor-default'} focus:outline-none`}
			onClick={onClick}
			disabled={disabled}>
			<img
				src={icon}
				alt='icon'
				className={classNameIMG}
			/>
		</button>
	);
}

export default IconButton;
